import React from 'react'
import AppChip from '../../../components/chips/AppChip'
import {
  UI_COLOR_ACCENT_ORANGE,
  UI_COLOR_DANGER,
  UI_COLOR_SUCCESS_ALT,
  UI_COLOR_TEXT_NEUTRAL
} from '../../../constants/uiColors'

export const SETTLEMENT_STATUS = {
  SETTLED: 'settled',
  PENDING: 'pending',
  NOT_SETTLED: 'not_settled'
}

export const SETTLEMENT_STATUS_LABELS = {
  [SETTLEMENT_STATUS.SETTLED]: 'Liquidado',
  [SETTLEMENT_STATUS.PENDING]: 'Por Liquidar',
  [SETTLEMENT_STATUS.NOT_SETTLED]: 'No Liquidado'
}

export function formatPendingSettlementLabel(settlementStatus, isSingleDayRange = true) {
  if (!isSingleDayRange) return '-'
  return SETTLEMENT_STATUS_LABELS[settlementStatus] || '-'
}

export function formatPendingSettlementCount(count, isSingleDayRange = true) {
  if (!isSingleDayRange) return '-'
  return count ?? 0
}

export function getPendingSettlementLabelColor(label) {
  if (label === SETTLEMENT_STATUS_LABELS[SETTLEMENT_STATUS.PENDING]) return UI_COLOR_ACCENT_ORANGE
  if (label === SETTLEMENT_STATUS_LABELS[SETTLEMENT_STATUS.SETTLED]) return UI_COLOR_SUCCESS_ALT
  if (label === SETTLEMENT_STATUS_LABELS[SETTLEMENT_STATUS.NOT_SETTLED]) return UI_COLOR_DANGER
  return UI_COLOR_TEXT_NEUTRAL
}

export function renderPendingSettlementLabel(settlementStatus, isSingleDayRange = true) {
  const label = formatPendingSettlementLabel(settlementStatus, isSingleDayRange)
  if (label === '-') return label

  return (
    <AppChip
      label={label.toUpperCase()}
      variant={
        {
          [SETTLEMENT_STATUS.SETTLED]: 'success',
          [SETTLEMENT_STATUS.PENDING]: 'warning',
          [SETTLEMENT_STATUS.NOT_SETTLED]: 'danger'
        }[settlementStatus]
      }
    />
  )
}

export const SETTLEMENT_STATUS_HEADER = {
  label: 'ESTADO DE LIQUIDACIÓN',
  description:
    'Indica si el usuario liquidó durante el día seleccionado. Liquidado: el usuario al menos ha liquidado 1 vez en el día. Por liquidar: el día sigue en curso y el usuario aún no ha liquidado. No liquidado: el día terminó y el usuario nunca liquidó.'
}

export const SETTLEMENT_STATUS_HEADER_DELIVERIES = {
  label: 'ESTADO DE LIQUIDACIÓN',
  description:
    'Indica si el usuario liquidó durante el día seleccionado. Liquidado: el usuario al menos ha liquidado 1 vez en el día. Por liquidar: el día sigue en curso y el usuario aún no ha liquidado. No liquidado: el día terminó y el usuario nunca liquidó.'
}

export const SETTLEMENT_STATUS_FILTER_OPTIONS = [
  { label: SETTLEMENT_STATUS_LABELS[SETTLEMENT_STATUS.SETTLED], value: SETTLEMENT_STATUS.SETTLED },
  { label: SETTLEMENT_STATUS_LABELS[SETTLEMENT_STATUS.PENDING], value: SETTLEMENT_STATUS.PENDING },
  {
    label: SETTLEMENT_STATUS_LABELS[SETTLEMENT_STATUS.NOT_SETTLED],
    value: SETTLEMENT_STATUS.NOT_SETTLED
  }
]

export const SETTLEMENT_STATUS_MULTI_DAY_NOTE =
  'Este filtro solo está disponible cuando el periodo de búsqueda es de un día.'
